import { lazy, Suspense } from "react";

import { SilentBoundary } from "@/components/follows/StorefrontFollowSlot";

// Lazy for the reason the Follow slot is: a public route's entry chunk must import no Clerk.
const StorefrontWantGate = lazy(() => import("@/components/wants/StorefrontWantGate"));

/**
 * Where a storefront card offers Want, and the only thing the card page imports to do it.
 *
 * Holds no session knowledge and no Clerk import. A chunk that fails to load is as silent as one
 * that throws, which is why the boundary wraps the Suspense.
 */
export function StorefrontWantSlot(
  { slug, itemId, cardName }: { slug: string; itemId: string; cardName: string; },
) {
  return (
    <SilentBoundary>
      <Suspense fallback={null}>
        <StorefrontWantGate slug={slug} itemId={itemId} cardName={cardName} />
      </Suspense>
    </SilentBoundary>
  );
}
